'use strict';

L.Draw.Text = L.Draw.Marker.extend({
  statics: {
    TYPE: 'text'
  },

  initialize: function (map, options) {
    // Save the type so super can fire, need to do this as cannot do this.TYPE :(
    this.type = L.Draw.Text.TYPE;

    L.Draw.Feature.prototype.initialize.call(this, map, options);
  }
});


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/leaflet/DrawText.js